// extracted by mini-css-extract-plugin
module.exports = {"textArea":"SuspectWordListConfig-textArea-5b38f68c18eb918cfa3fc36a02027124"};